import React from "react";
import { styled } from "styled-components";

export const FooterWrapper = styled.footer`
  margin-top: auto;
  text-align: left;
  padding: ${({ theme }) => theme.spacing.md};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  color: black;
`;

export const Footer: React.FC = () => {
  return (
    <FooterWrapper>
      © {new Date().getFullYear()} ACF Automation. All rights reserved.
    </FooterWrapper>
  );
};
